
import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";
import { Template } from "./models/template.model";


export const TEMPLATE_ENDPOINT = 'templates'
export const TEMPLATE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(TEMPLATE_ENDPOINT);


export const templateStateConfig: SignalStoreConfig<QueryState<Template>> = {
  initState: {
    list: []
  }
}